import { render, staticRenderFns } from "./characteristic.vue?vue&type=template&id=11804cde&scoped=true"
import script from "./characteristic.vue?vue&type=script&lang=js"
export * from "./characteristic.vue?vue&type=script&lang=js"
import style0 from "./characteristic.vue?vue&type=style&index=0&id=11804cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11804cde",
  null
  
)

export default component.exports